import React, { useEffect, useState } from 'react';
import "./CabBooking.css";
import prevIcon from "../../assets/icons/coloredPrev.svg";
import { useLocation, useNavigate } from "react-router-dom";
import axios from 'axios';
import { useSelector } from 'react-redux';
import useAuth from '../../customHooks/useAuth.js';
import { toast } from 'react-toastify';

// For Setting Up data for Requests
// import { useDispatch } from 'react-redux';
// import {setCabRequests} from "../../redux/userSlice.js";
import { baseUrl } from '../../common/baseUrl';
import PageLoader from '../components/PageLoader/PageLoader';
import axiosInstance from '../../axiosInstance/axiosInstance.js';
import PromoSection from '../PostCheckInRequest/FoodSummary/PromoSection';
import { toHotelISO } from "../../common/hotelTime";


export default function CabBooking() {

  const navigate = useNavigate();
  // const dispatch = useDispatch();
  const location = useLocation();
  

  const booking_id = location.state?.bookingId || "";
  const hotel_id = location.state?.hotelId || "";
  // For Hotel View
  const hotelName = location.state?.hotelName || "";
  const hotelAddress = location.state?.hotelAddress || "";
  const checkInDate = location.state?.checkInDate || "";
  const checkOutDate = location.state?.checkOutDate || "";
  const status = location.state?.status || "";
  const activeTab = location.state?.activeTab || "";
  const booking_code = location.state?.booking_code || "";




  const [errors, setErrors] = useState({});
  const [bookedRooms, setBookedRooms] = useState([]);

  // Refresh Handle
  useAuth();

  // Check If the user got id or not 
  useEffect(() => {
    const checkdata = ()=>{
  
      if(booking_id==="" || hotel_id===""){
        navigate("/bookings",{state : {activeRequests : "requests"}});
      }
    }
    checkdata();
  },[])


  // User Id 
  const userId = useSelector((state) => state.user.userId);

  // Gets Data for Booking Booked Rooms for user 
  useEffect(() => {
    const getBookedRooms = async () => {
      try {
        const response = await axiosInstance.get(
          `/api/v1/hotels/${hotel_id}/bookings/${booking_id}/booked-rooms`
        );

        const data = response.data.data;
        const roomDetails = data.map(room => ({
          id: room.id,
          number_of_guests: room.number_of_guests,
          guests: room.guests || []
        }));
        // console.log("Guests : ",data);
        
        setBookedRooms(roomDetails);

      } catch (error) {
        console.log(error);
      }
    };
    getBookedRooms();
  }, []);

  // The request belongs to the room the guest is actually staying in. Only the booker
  // can match no room at all — they hold the booking without being on any of its rooms —
  // and for them the first room is as good as any.
  const requestBookedRoomId = () => {
    const ownRoom = bookedRooms.find((room) =>
      room.guests.some((guest) => guest.user_id === userId),
    );

    return (ownRoom || bookedRooms[0])?.id;
  };


  // Backward Button
  const handleClick = () => {
    navigate(`/bookings/${booking_id}`);
  };

  // State for form fields and validation
  const [formData, setFormData] = useState({
    pickupLocation: '',
    time: '',
    number_of_people : null
  });
  
  const validateField = (field, value) => {
    try{
      const newErrors = { ...errors };
      const numberRegex = /^[1-9][0-9]*$/; // Regex to ensure only positive integers greater than 0
  
      switch(field){
  
        case "pickupLocation":
          if(!value.trim()){
            newErrors.pickupLocation = "Pick up location is required";
          }
          else{
            newErrors.pickupLocation = "";
          }
          break;
        
        case "time":
          if(!value.trim()){
            newErrors.time = "Time is required";
          }
          else{
            newErrors.time = "";
          }
          break;
  
        case "number_of_people":
          if(!numberRegex.test(value)){
            newErrors.number_of_people = "Number of people must be a positive integer greater than 0 and not start with 0";
          }
          else{
            newErrors.number_of_people = "";
          }
          break;
        
        default:
          break;
      }
      setErrors(newErrors);
    }catch(error){
      console.log(error);
    }

  }

  // Function to handle form validation
  const validateForm = () => {
    try{
      const newErrors = {};
      const specialCharRegex = /[!@#$%^&*()?:{}|<>]/; // Regex for special characters
      const numberRegex = /^[1-9][0-9]*$/; // Regex to ensure only positive integers greater than 0
  
      if (!formData.pickupLocation.trim()) {
        newErrors.pickupLocation = "Pick up location is required";
      } else if (specialCharRegex.test(formData.pickupLocation)) {
        newErrors.pickupLocation = "Special characters are not allowed";
      }
  
      if (!formData.time) {
        newErrors.time = "Time is required";
      }
  
      if (!numberRegex.test(formData.number_of_people)) {
        newErrors.number_of_people = "Number of people must be a positive integer greater than 0 and not start with 0";
      }
  
      setErrors(newErrors);
      return Object.keys(newErrors).length === 0; // Return true if no errors

    }catch(error){
      console.log(error)
    }
  };

  // Handle Change
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData(prevData => ({
      ...prevData,
      [name]: value
    }));

    // const formErrors = validateForm({
    //   ...formData,
    //   [name]: value
    // });
    // setErrors(formErrors);
    validateField(name, value);
  };



  
  const [isLoading,setIsLoading] = useState(false);

  // Applied promo (offer object | null). Price is quoted by the hotel later,
  // so we only attach the code here — no live discount preview.
  const [appliedPromo,setAppliedPromo] = useState(null);
  const handleApplyPromo = (offer) => setAppliedPromo(offer);
  const handleRemovePromo = () => setAppliedPromo(null);


  // Function to handle form submission
  const handleRequestCab = async () => {
   try {

    if(!validateForm()) {
      // console.log("Form Has Some Errors Need to fix")
      return;
    }

      setIsLoading(true);
      // console.log("Time : " + formData.time)

      // Format function without converting to UTC




      // const formattedTime =  formatLocalToISO(formData.time);
      // const localDate = formattedTime.toLocaleString(); // This will give you the local time based

      const isoDateTimeWithInd = toHotelISO(formData.time);

      // console.log("IND",isoDateTimeWithInd)



      // Convert number_of_people to integer
      const numberOfPeople = parseInt(formData.number_of_people, 10);

      const formInputs = {
        number_of_people: numberOfPeople,
        pick_up_location: formData.pickupLocation,
        time_of_arrival: isoDateTimeWithInd, // Set time in ISO format
        promo_code : appliedPromo?.code || ""
      };
      
      // console.log("Form Data  : ", formInputs);

      const bookedRoomId = requestBookedRoomId();

      if (!bookedRoomId) {
        toast.error("Could not find a room on this booking");
        return;
      }

      const response = await axiosInstance.post(`/api/v1/users/${userId}/bookings/${booking_id}/booked-rooms/${bookedRoomId}/guest-requests/pre-checkin/cab-request/`, formInputs);

      // console.log("Success Cab Request : ", response.data);
      toast.success("PreCheckIn Cab Request Created Successfully");
    
      // Move to  Requests 
      navigate("/bookings",{state : {activeRequests : "requests"}})
    } 
    catch (error) {
      toast.error(error?.response?.data?.message || "Some Error Occured");
      console.log(error);
    }
    finally{
      setIsLoading(false);
    }
    
  };


 

  return (
    <>
      {
        isLoading && <PageLoader/>
      }
      <div className="cab-booking">

        {/* Header of Page */}
        <div className="cab-header">
          <div className="cab-content">
            <div className='prev-icon' onClick={handleClick}>
              <img src={prevIcon} alt="" />
            </div>
            <div className='cab-data'>
              <div className='cab-data-header'>
                <h6>Book your cab to your stay</h6>
                <p>
                  Reserve a comfortable and reliable transportation option for your convenient journey.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Pick Up Message  */}
        <div className="pickup">
          {/* Text Area */}

          <div className="textarea-pickup">
            <div className="form-pickup">
              <label htmlFor="pickupText">
                <h4>Drop off Location</h4>
              </label>
            </div>
            <div className="form-textArea">
              <textarea
                rows="4"
                cols="10"
                value={hotelName + " " + hotelAddress}
                disabled
              />
            
            </div>
          </div>

          <div className="textarea-pickup">
            <div className="form-pickup">
              <label htmlFor="pickupText">
                <h4>Pick up Location</h4>
              </label>
            </div>
            <div className="form-textArea">
              <textarea
                name="pickupLocation"
                rows="4"
                cols="10"
                value={formData.pickupLocation}
                onChange={handleChange}
              />
              {errors.pickupLocation && <p className="error-message">{errors.pickupLocation}</p>}
            </div>
          </div>

          {/* Cab Request Number of Guest */}
          <div className="guest">
            <div className="form-guest">
              <label htmlFor="guest">
                <h4>Number of People</h4>
              </label>
            </div>

            <div className="form-guestText">
              <input
                type="text"
                name="number_of_people" // Ensure the name matches the formData key
                value={formData.number_of_people || ""} // Set value from state
                onChange={handleChange}
                maxLength={2}

              />
              {errors.number_of_people && <p className="error-message">{errors.number_of_people}</p>}
            </div>
          </div>



          {/* Promo Code */}
          <PromoSection
            userId={userId}
            hotelId={hotel_id}
            service="PreCheckin Cab Request"
            appliedPromo={appliedPromo}
            onApply={handleApplyPromo}
            onRemove={handleRemovePromo}
            previewDiscount={false}
          />

          {/* Cab Request Input Field */}
          <div className="request-cab">
            <div className="request-cab-header">
              <h4>When do you want the cab</h4>
            </div>
            <div className="request-cab-btns">
              <div className="request-cab-time">
                <input
                  type="datetime-local"
                  name="time"
                  value={formData.time}
                  onChange={handleChange}
                />
                {errors.time && <p className="error-message">{errors.time}</p>}
              </div>
              
              {/* Request Button */}
              <div className="request-cab-btn">
                <button
                  onClick={handleRequestCab}
                  disabled={ formData.time === "" || formData.pickupLocation === "" || formData.number_of_people===""}
                >
                  Request Cab
                </button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </>
  );
}
